import { Check } from "lucide-react";
import { JOIN_PALETTES } from "@wedding/shared";

interface PaletteSelectorProps {
  selected: string | undefined;
  onChange: (palette: string) => void;
}

export function PaletteSelector({ selected, onChange }: PaletteSelectorProps) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {JOIN_PALETTES.map((palette) => {
        const isSelected = selected === palette.id;
        return (
          <button
            key={palette.id}
            onClick={() => onChange(palette.id)}
            className={[
              "flex items-center gap-3 rounded-2xl border-2 p-3 transition-all cursor-pointer text-left",
              isSelected
                ? "border-primary bg-primary/5"
                : "border-border hover:border-primary/40",
            ].join(" ")}
          >
            <div className="flex gap-1 shrink-0">
              {palette.colors.map((color, i) => (
                <span
                  key={i}
                  className="h-5 w-5 rounded-full border border-border"
                  style={{ background: color }}
                />
              ))}
            </div>
            <span className="flex-1 text-sm font-medium">{palette.label}</span>
            {isSelected && <Check className="h-4 w-4 text-primary shrink-0" />}
          </button>
        );
      })}
    </div>
  );
}
